import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Link } from 'react-router-dom';
import ScrollMenu from 'react-horizontal-scroll-menu';
import PropTypes from 'prop-types';

import { productsArrayPropTypes, slidersArrayPropTypes } from 'helpers/propTypes';
import { sectionsArray } from 'views/Home/constants';

import Loading from 'components/commons/Loading';
import MarketingNewsletter from 'components/commons/MarketingNewsletter';
import { isSlideImage, useRenderableHeroSliders } from 'helpers/sliders';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './HomeD8.scss';

const HomeD8 = (props) => {
  const {
    cartel, categories, categoriesHome, currentSection, instagram, items, loading, onSectionClick,
    renderItem, sliders, marcasHome, getImageHomeSelected, addresses, linkIg,
    newsletter, setNewsletter, submitNewsletter, loadingNewsletter, client,
  } = props;
  
  const [activeMapIndex, setActiveMapIndex] = useState(0);
  const {
    heroSliders,
    markHeroSlideReady,
    markHeroSlideFailed,
  } = useRenderableHeroSliders(sliders);
  
  const buildIgName = (link) => {    if (!link) return '';
    try {
      const url = new URL(link);
      const path = url.pathname.split('/').filter(Boolean);
      return path.length > 0 ? ` Seguinos en @${path[0]}` : '';
    } catch (e) {
      return '';
    }
  };

  const displayItems = items;
  const buildMapSrcFromAddress = (addressText) => (
    `https://maps.google.com/maps?width=700&height=440&hl=en&q=${encodeURIComponent(addressText)}&ie=UTF8&t=&z=16&iwloc=B&output=embed`
  );

  const getAddressText = (addressItem) => {
    if (!addressItem) return '';
    if (addressItem.address) return addressItem.address;
    if (addressItem.direction) return addressItem.direction;
    if (addressItem.direccion) return addressItem.direccion;
    if (addressItem.fullAddress) return addressItem.fullAddress;

    const composedAddress = [
      addressItem.street,
      addressItem.number,
      addressItem.locality,
      addressItem.city,
      addressItem.province,
    ].filter(Boolean).join(' ');

    return composedAddress;
  };

  const getMapSrc = (addressItem) => {
    if (!addressItem) return '';
    if (addressItem.mapUrl) return addressItem.mapUrl;
    if (addressItem.mapSrc) return addressItem.mapSrc;

    const addressText = getAddressText(addressItem);
    return addressText ? buildMapSrcFromAddress(addressText) : '';
  };

  const renderSlider = () => {
    if (!heroSliders.length) return null;

    if (heroSliders.length === 1) {
      const slide = heroSliders[0];
      return (
        <div data-testid="slider" className="hero-carousel">
          <div className="carousel-button-d8">
            <div className="main-slider-d8">
              {isSlideImage(slide) ? (
                <img
                  className="main-slider-img-d8"
                  src={slide.image}
                  alt={slide.text}
                  loading="eager"
                  decoding="async"
                  onLoad={() => markHeroSlideReady(slide)}
                  onError={() => markHeroSlideFailed(slide)}
                />
              ) : (
                <video
                  src={slide.image}
                  autoPlay
                  muted
                  loop
                  controls
                  playsInline
                  preload="auto"
                  className="main-slider-video-d8"
                  onLoadedData={() => markHeroSlideReady(slide)}
                  onError={() => markHeroSlideFailed(slide)}
                >
                  <track kind="captions" srcLang="en" label="English_captions" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
            <Link to="/productos"><button className="cbutton-d8" type="button">Ver mÃ¡s productos</button></Link>
          </div>
        </div>
      );
    }

    return (
      <div data-testid="slider" className="hero-carousel">
        <div className="carousel-button-d8">
          <Carousel
            autoPlay
            showStatus={false}
            showThumbs={false}
            swipeable={false}
          >
            {heroSliders.map((slide) => (
              <div className="main-slider-d8" key={slide.id || slide.image}>
                {isSlideImage(slide) ? (
                  <img
                    className="main-slider-img-d8"
                    src={slide.image}
                    alt={slide.text}
                    loading="eager"
                    decoding="async"
                    onLoad={() => markHeroSlideReady(slide)}
                    onError={() => markHeroSlideFailed(slide)}
                  />
                ) : (
                  <video
                    src={slide.image}
                    autoPlay
                    muted
                    loop
                    controls
                    playsInline
                    preload="auto"
                    className="main-slider-video-d8"
                    onLoadedData={() => markHeroSlideReady(slide)}
                    onError={() => markHeroSlideFailed(slide)}
                  >
                    <track kind="captions" srcLang="en" label="English_captions" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            ))}
          </Carousel>
          <Link to="/productos"><button className="cbutton-d8" type="button">Ver más productos</button></Link>
        </div>
      </div>
    );
  };

  const renderCategoriesMenu = () => (
    <div className="navbar-categories-d8">
      <ScrollMenu
        alignCenter={false}
        arrowDisabledClass="scroll-menu-arrow--disabled-d8"
        arrowLeft={<span className="arrow-prev-d8">{' < '}</span>}
        arrowRight={<span className="arrow-next-d8">{' > '}</span>}
        data={categories.map((category) => (
          <Link key={category.id} to={`/productos/${category.code}`}>
            {category.name}
          </Link>
        ))}
        dragging={false}
        hideArrows
        hideSingleArrow
        wheel={false}
      />
    </div>
  );

  const renderCategoriesGrid = () => {
    if (categoriesHome.length < 4) return null;

    const [first, second, third, fourth] = categoriesHome;

    return (
      <div className="section-d8">
        <div className="category-images-d8">
          <div className="row">
            <div className="col-lg-5">
              <div className="img-button-d8 column-flex-d8">
                <img alt="category-img-1" src={getImageHomeSelected(first)} />
                <Link to={`/productos/${first.category.code}`}><button type="button">{first.category.name}</button></Link>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row">
                <div className="img-button-d8 column-flex-d8">
                  <img alt="category-img-2" className="img-altura-d8" src={getImageHomeSelected(second)} width={90} />
                  <Link to={`/productos/${second.category.code}`}><button type="button">{second.category.name}</button></Link>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 column-flex-d8">
                  <div className="img-button-d8 column-flex-d8">
                    <img alt="category-img-3" src={getImageHomeSelected(third)} />
                    <Link to={`/productos/${third.category.code}`}><button type="button">{third.category.name}</button></Link>
                  </div>
                </div>
                <div className="col-lg-6 column-flex-d8">
                  <div className="img-button-d8 column-flex-d8">
                    <img alt="category-img-4" src={getImageHomeSelected(fourth)} />
                    <Link to={`/productos/${fourth.category.code}`}><button type="button">{fourth.category.name}</button></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMarcasHome = () => (
    <div className="section-d8">
      <div className="marcasHome-d8">
        {marcasHome.map((marca) => (
          console.log(marca),
          <Link key={marca.category.id} to={`/productos/${marca.category.code}`}>
            <img alt={marca.category.name} src={marca.category.image ? marca.category.image : marca.category.imageHome} style={{ width: '100%' }} />
          </Link>
        ))}
      </div>
    </div>
  );

  const renderProductsTabs = () => (
    <div className="section-d8">
      <div className="row align-items-center">
        <div className="col text-center">
          <div className="new-arrivals-sorting-d8">
            <ul className="arrivals-grid-sorting-d8 clearfix button-group-d8 filters-button-group-d8">
              {sectionsArray.map((section) => (
                <button
                  className={`green-button-d8 ${section.value === currentSection?.value ? 'active' : ''}`}
                  data-testid={`section-${section.value}`}
                  key={section.value}
                  onClick={() => onSectionClick(section.value)}
                  type="button"
                >
                  {section.label}
                </button>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="row align-items-center product-slider-container-d8" data-testid="carousel">
        {loading && <Loading />}
        {!loading && (
          <>
            {!displayItems.length && <h4 className="text-center">No se encontraron productos</h4>}
            {!!displayItems.length && displayItems.map((item) => renderItem(item))}
          </>
        )}
      </div>
      <div className="row justify-content-center">
        <Link to="/productos"><button type="button" className="green-button-d8">Ver todos los productos</button></Link>
      </div>
    </div>
  );

  const renderCartel = () => {
    if (!cartel || !cartel.length || !cartel[0]) return null;
    
    const cartelItem = cartel[0];
    if (!cartelItem.image) return null;
    
    return (
      <div className="section-d8">
        <div className="cartel-banner-d8" style={{ backgroundImage: `url(${cartelItem.image})` }}>
          <div className="cartel-content-d8">
            <div className="cartel-text-d8">
              <span className="cartel-category-d8">{cartelItem.category?.name || ''}</span>
              <span className="cartel-description-d8">{cartelItem.description || ''}</span>
              {cartelItem.category?.code && (
                <Link to={`/productos/${cartelItem.category.code}`} className="cartel-button-d8">
                  Ver Colección
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContact = () => {
    if (!addresses || addresses.length === 0) return null;

    return (
      <div className="section-d8">
        <div className="info-container-d8">
          <ul>
            <li><span>Visitá nuestro local</span></li>
            <li><Link to="/contacto"><button type="button" className="green-button-d8">Cómo llegar</button></Link></li>
            <li>
              {addresses.map((addr, index) => (
                <button
                  key={addr.id || index}
                  type="button"
                  className={`green-button-d8 ${index === activeMapIndex ? 'active' : ''}`}
                  onClick={() => setActiveMapIndex(index)}
                >
                  {addr.name}
                </button>
              ))}
            </li>
            <li>
              {addresses.map((addr, index) => (
                getMapSrc(addr) ? (
                  <iframe
                    key={addr.id || index}
                    className={index === activeMapIndex ? 'maps-panoram-d8' : 'mapsInv-d8'}
                    src={getMapSrc(addr)}
                    width="100%"
                    height="100%"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allow="accelerometer"
                    title={addr.name}
                  />
                ) : null
              ))}
            </li>
            <li>
              <span>Seguínos en</span>
              <br />
              <a href={linkIg} target="_blank" rel="noopener noreferrer">{buildIgName(linkIg)}</a>
            </li>
            <li className="social-media-d8">
              {instagram.slice(0, 3).map((publicacion) => (
                <div className="instagram-image-d8" key={`instagram-${publicacion.id}`}>
                  <iframe src={`${publicacion.link}embed`} className="instagram-iframe-d8" frameBorder="0" scrolling="no" allowtransparency="true" title={`instagram-${publicacion.id}`} />
                </div>
              ))}
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="home-page">
      {renderSlider()}
      {renderCategoriesMenu()}
      <div className="container">
        <div className="row">
          <div className="col">
            {renderCategoriesGrid()}
            {marcasHome.length > 0 && renderMarcasHome()}
            {renderProductsTabs()}
            {renderCartel()}
            {renderContact()}
            <MarketingNewsletter
              email={newsletter}
              onEmailChange={setNewsletter}
              onSubmit={submitNewsletter}
              loading={loadingNewsletter}
              clientName={client?.name_show || client?.name}
              variant="minimal"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

HomeD8.propTypes = {
  cartel: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  categoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  currentSection: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  instagram: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  items: productsArrayPropTypes.isRequired,
  newArrivals: productsArrayPropTypes,
  mostSelled: productsArrayPropTypes,
  offers: productsArrayPropTypes,
  loading: PropTypes.bool.isRequired,
  marcasHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onSectionClick: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  sliders: slidersArrayPropTypes.isRequired,
  getImageHomeSelected: PropTypes.func,
  addresses: PropTypes.arrayOf(PropTypes.shape()),
  newsletter: PropTypes.string,
  setNewsletter: PropTypes.func.isRequired,
  submitNewsletter: PropTypes.func.isRequired,
  loadingNewsletter: PropTypes.bool,
  client: PropTypes.shape(),
};

HomeD8.defaultProps = {
  getImageHomeSelected: (cat) => cat?.category?.imageHome || '',
  addresses: [],
  newArrivals: [],
  mostSelled: [],
  offers: [],
  newsletter: '',
  loadingNewsletter: false,
  client: null,
};

export default HomeD8;
